import React from 'react';
import {
  Button,
  Flex,
  HStack,
  Select,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

export const PAGE_SIZE_OPTIONS = [10, 30, 50, 100];

/**
 * Barra de paginación compartida: anterior/siguiente + filas por página.
 * page es 0-based.
 */
export default function TablePagination({
  page = 0,
  setPage,
  totalPages = 0,
  pageSize = 10,
  setPageSize,
  pageSizeOptions = PAGE_SIZE_OPTIONS,
}) {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');
  const muted = useColorModeValue('gray.500', 'gray.400');
  const safeTotal = Math.max(Number(totalPages) || 0, 1);
  const current = Math.min(Math.max(Number(page) || 0, 0), safeTotal - 1);
  const canPrev = current > 0;
  const canNext = current + 1 < safeTotal;

  const handlePageSizeChange = (e) => {
    const next = Number(e.target.value);
    if (!Number.isFinite(next) || next <= 0) return;
    setPageSize?.(next);
    setPage?.(0);
  };

  return (
    <Flex
      mt={2}
      mb={4}
      px={{ base: 3, md: 4 }}
      pt={2}
      borderTopWidth="1px"
      borderColor={borderColor}
      direction={{ base: 'column', md: 'row' }}
      align={{ base: 'stretch', md: 'center' }}
      justify="space-between"
      gap={2}
      wrap="wrap"
    >
      <HStack spacing={1.5} justify={{ base: 'space-between', md: 'flex-start' }}>
        <Text fontSize="xs" color={muted} whiteSpace="nowrap">
          Filas
        </Text>
        <Select
          size="xs"
          w="68px"
          h="26px"
          minH="26px"
          bg="white"
          fontSize="xs"
          value={pageSize}
          onChange={handlePageSizeChange}
          isDisabled={!setPageSize}
        >
          {pageSizeOptions.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </Select>
      </HStack>

      <HStack
        spacing={2}
        justify={{ base: 'space-between', md: 'flex-end' }}
        flex="1"
      >
        <Button
          size="xs"
          h="26px"
          minW="64px"
          px={2}
          variant="outline"
          fontWeight="medium"
          onClick={() => setPage?.((prev) => Math.max(prev - 1, 0))}
          isDisabled={!canPrev}
        >
          Anterior
        </Button>
        <Text fontSize="xs" color="gray.600" minW="88px" textAlign="center">
          {current + 1} / {safeTotal}
        </Text>
        <Button
          size="xs"
          h="26px"
          minW="64px"
          px={2}
          variant="outline"
          fontWeight="medium"
          onClick={() =>
            setPage?.((prev) => Math.min(prev + 1, safeTotal - 1))
          }
          isDisabled={!canNext}
        >
          Siguiente
        </Button>
      </HStack>
    </Flex>
  );
}
